"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12 5c-.28 0-.53.11-.71.29L8 8.59l-3.29-3.3a1.003 1.003 0 00-1.42 1.42l4 4c.18.18.43.29.71.29s.53-.11.71-.29l4-4A1.003 1.003 0 0012 5z"];
//# sourceMappingURL=chevron-down.js.map